import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyRequestModel } from '../models/request/company-request';
import { TestDocuwareConnectionModel } from '../models/request/test-docuware-connection-model';
import { CompanyResponseModel } from '../models/response/company-response';
import { ResultOfT } from '../models/response/result';
import { ClientCredentialsModel } from '../models/response/userInfo-response';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})

export class BackgroundService extends BaseService {

  constructor(httpService: HttpClient, private router: Router) {
    super(httpService);
  }


  getOCRServiceStatus() {
    return this.get<ResultOfT<string>>('HealthCheck/OCRFunc' );
  }

  getRecycleBinServiceStatus() {
    return this.get<ResultOfT<string>>('HealthCheck/RecycleBin');
  }

  
}
